export default __webpack_public_path__ + "static/media/architecture3Chi.b1c97fc7.jpg";